import { endOfDay } from 'date-fns';
import { call, put, takeLatest } from 'typed-redux-saga/macro';
import {
  cancelEVisit,
  createEVisitRule,
  deleteEVisitRule,
  getEVisitRules,
  getEVisitsEventsOld,
  getEVisitsTypesForDay,
  getOfficeHours,
  updateEVisitRule,
} from '../../services/e-visits';

import { actions } from '../ducks/e-visits';
import { getTagOptionsFromResponse } from './reservation-form/reservation-form-saga.utils';
import { memberApiV2 } from 'lib/api';
import { select } from 'typed-redux-saga';
import TStore from 'types/store';

function* getEventsRequest({ payload }: ReturnType<typeof actions.getEventsRequest>) {
  try {
    const providerId = yield* select((store: TStore) => store.users.business[0].id);
    const response = yield* call(memberApiV2.getEVisitsEvents, providerId, payload);
    yield* put(actions.getEventSuccess(response.data.data.dates));
  } catch (error) {
    console.log('getEventsRequest error', error);
    yield* put(actions.getEventError());
  }
}

function* getEventsTypesForDayRequest({
  payload,
}: ReturnType<typeof actions.getEventsTypesForDayRequest>) {
  try {
    const providerId = yield* select((store: TStore) => store.users.business[0].id);
    const response = yield* call(getEVisitsTypesForDay, providerId, payload);
    yield* put(actions.getEventsTypesForDaySuccess(response.data.data.dates));
  } catch (error) {
    console.log('getEventsTypesForDayRequest error', error);
    yield* put(actions.getEventsTypesForDayError());
  }
}

function* getOfficeHoursRequest({ payload }: ReturnType<typeof actions.getOfficeHoursRequest>) {
  try {
    const providerId = yield* select((store: TStore) => store.users.business[0].id);

    const response = yield* call(getOfficeHours, providerId, payload);
    yield* put(actions.getOfficeHoursSuccess(response.data.data.officeHours));
  } catch (error) {
    console.log('getOfficeHoursRequest error', error);
    yield* put(actions.getOfficeHoursError());
  }
}

function* cancelEVisitRequest({ payload }: ReturnType<typeof actions.cancelEVisitRequest>) {
  try {
    const providerId = yield* select((store: TStore) => store.users.business[0].id);
    yield* call(cancelEVisit, providerId, payload.orderId, payload.reason);
    yield* put(actions.cancelEVisitSuccess());
  } catch (error) {
    console.log('cancelEVisitRequest error', error);
    yield* put(actions.cancelEVisitError());
  }
}

function* getFeedEVisitsRequest(_: ReturnType<typeof actions.getFeedEVisitsRequest>) {
  try {
    const providerId = yield* select((store: TStore) => store.users.business[0].id);
    const response = yield* call(getEVisitsEventsOld, providerId, {
      dateFrom: new Date().toISOString(),
      dateTo: endOfDay(Date.now()).toISOString(),
    });
    yield* put(actions.getFeedEVisitsSuccess(response.data.data.dates));
  } catch (error) {
    console.log('getFeedEVisitsRequest error', error);
    yield* put(actions.getFeedEVisitsError());
  }
}

function* getEVisitsRulesRequest({ payload }: ReturnType<typeof actions.getEVisitsRulesRequest>) {
  try {
    const providerId = yield* select((store: TStore) => store.users.business[0].id);
    const response = yield* call(getEVisitRules, providerId, payload);
    //@ts-expect-error yes!
    yield* put(actions.getEVisitsRulesSuccess(response.data.data.timeIntervals));
  } catch (error) {
    console.log('getEVisitsRulesRequest error', error);
    yield* put(actions.getEVisitsRulesError());
  }
}

function* createEVisitRuleRequest({ payload }: ReturnType<typeof actions.createEVisitRuleRequest>) {
  try {
    const providerId = yield* select((store: TStore) => store.users.business[0].id);
    yield* call(createEVisitRule, providerId, payload);
    yield* put(actions.createEVisitRuleSuccess());
  } catch (error) {
    console.log('createEVisitRuleRequest error', error);
    yield* put(actions.createEVisitRuleError((error as any).data));
  }
}

function* updateEVisitRuleRequest({ payload }: ReturnType<typeof actions.updateEVisitRuleRequest>) {
  try {
    const providerId = yield* select((store: TStore) => store.users.business[0].id);
    yield* call(updateEVisitRule, providerId, payload);
    yield* put(actions.updateEVisitRuleSuccess());
  } catch (error) {
    console.log('updateEVisitRuleRequest error', error);
    yield* put(actions.updateEVisitRuleError((error as any).data));
  }
}

function* deleteEVisitRuleRequest({ payload }: ReturnType<typeof actions.deleteEVisitRuleRequest>) {
  try {
    const providerId = yield* select((store: TStore) => store.users.business[0].id);
    yield* call(deleteEVisitRule, providerId, payload);
    yield* put(actions.deleteEVisitRuleSuccess());
  } catch (error) {
    console.log('deleteEVisitRuleRequest error', error);
    yield* put(actions.deleteEVisitRuleError((error as any).data));
  }
}

function* getOfficeRulesRequest({ payload }: ReturnType<typeof actions.getOfficeRulesRequest>) {
  try {
    const providerId = yield* select((store: TStore) => store.users.business[0].id);
    const response = yield* call(
      memberApiV2.getOfficeHoursRules,
      providerId,
      payload.medicalInstitutionId,
    );
    yield* put(actions.getOfficeRulesSuccess(response.data.data.rules));
  } catch (error) {
    console.log('getOfficesRulesRequest error', error);
    yield* put(actions.getOfficeRulesError());
  }
}

function* createOfficeRuleRequest({ payload }: ReturnType<typeof actions.createOfficeRuleRequest>) {
  try {
    const providerId = yield* select((store: TStore) => store.users.business[0].id);
    yield* call(memberApiV2.createOfficeHoursRule, providerId, {
      ...payload,
      workspaceId: payload.workspaceId,
    });
    yield* put(actions.createOfficeRuleSuccess());
  } catch (error) {
    console.log('createOfficeRuleRequest error', error);
    yield* put(actions.createOfficeRuleError((error as any).data));
  }
}

function* updateOfficeRuleRequest({ payload }: ReturnType<typeof actions.updateOfficeRuleRequest>) {
  try {
    const providerId = yield* select((store: TStore) => store.users.business[0].id);
    yield* call(memberApiV2.updateOfficeHoursRule, providerId, payload);
    yield* put(actions.updateOfficeRuleSuccess());
  } catch (error) {
    console.log('updateOfficeRuleRequest error', error);
    yield* put(actions.updateOfficeRuleError((error as any).data));
  }
}

function* deleteOfficeRuleRequest({ payload }: ReturnType<typeof actions.deleteOfficeRuleRequest>) {
  try {
    const providerId = yield* select((store: TStore) => store.users.business[0].id);
    yield* call(memberApiV2.deleteOfficeHoursRule, providerId, payload.id, payload.dateFrom);
    yield* put(actions.deleteOfficeRuleSuccess());
  } catch (error) {
    console.log('deleteOfficeRuleRequest error', error);
    yield* put(actions.deleteOfficeRuleError((error as any).data));
  }
}

function* getTagsRequest() {
  try {
    const resp = yield* call(memberApiV2.getTags);
    yield* put(actions.setTagOptions(getTagOptionsFromResponse(resp)));
  } catch (error) {
    console.log('getTagsRequest error', error);
    yield* put(actions.deleteOfficeRuleError((error as any).data));
  }
}

function* EVisitsSaga() {
  yield takeLatest(actions.getEventsRequest, getEventsRequest);
  yield takeLatest(actions.getEventsTypesForDayRequest, getEventsTypesForDayRequest);
  yield takeLatest(actions.getOfficeHoursRequest, getOfficeHoursRequest);
  yield takeLatest(actions.cancelEVisitRequest, cancelEVisitRequest);
  yield takeLatest(actions.getFeedEVisitsRequest, getFeedEVisitsRequest);

  yield takeLatest(actions.getEVisitsRulesRequest, getEVisitsRulesRequest);
  yield takeLatest(actions.createEVisitRuleRequest, createEVisitRuleRequest);
  yield takeLatest(actions.updateEVisitRuleRequest, updateEVisitRuleRequest);
  yield takeLatest(actions.deleteEVisitRuleRequest, deleteEVisitRuleRequest);

  yield takeLatest(actions.getOfficeRulesRequest, getOfficeRulesRequest);
  yield takeLatest(actions.createOfficeRuleRequest, createOfficeRuleRequest);
  yield takeLatest(actions.updateOfficeRuleRequest, updateOfficeRuleRequest);
  yield takeLatest(actions.deleteOfficeRuleRequest, deleteOfficeRuleRequest);
  yield takeLatest(actions.getTagsRequest, getTagsRequest);
}

export default EVisitsSaga;
